import { Children, ReactElement, ReactNode } from 'react'
import { Box } from '@mui/material'

export type TwoColumnGridProps = {
  children: ReactNode
  /**
   * Fill the left column top to bottom before the right one, so lists read down
   * the columns. Default: false (fill row by row).
   */
  fillColumnsFirst?: boolean
}

/** Lays out its children in two equal-width columns. */
export const TwoColumnGrid = ({
  children,
  fillColumnsFirst = false,
}: TwoColumnGridProps): ReactElement => (
  <Box
    display="grid"
    gridTemplateColumns="repeat(2, minmax(0, 1fr))"
    gap={0.5}
    {...(fillColumnsFirst && {
      gridTemplateRows: `repeat(${Math.ceil(Children.toArray(children).length / 2)}, auto)`,
      gridAutoFlow: 'column',
    })}
  >
    {children}
  </Box>
)
